import ScrollMagic from "scrollmagic";

/**
 * Hero.Slider and Hero.Image are using the same animnation,
 * so we abstract it here.
 */
export default class HeroSlideAnimation {
	constructor(element, contentElement) {
		this.element = element;
		this.contentElement = contentElement;

		// init only after everything else is finished
		window.addEventListener('load', () => requestAnimationFrame(() => this.initParallaxScroll()));
	}

	initParallaxScroll() {
		this.whiteTriangle = this.element.querySelector('.white-triangle'); // desktop
		this.yellowLines = this.element.querySelector('.yellow-lines'); // desktop
		this.greyTriangles = this.element.querySelector('.grey-triangles'); // desktop
		this.whiteYellow = this.element.querySelector('.white-yellow'); // mobile
		this.greyTrianglesMobile = this.element.querySelector('.grey-triangles--mobile'); // mobile

		const controller = new ScrollMagic.Controller();
		const scene = new ScrollMagic.Scene({
			duration: this.element.clientHeight * 0.95,
			offset: 5,
			reverse: true,
			//loglevel: 3,
		});

		window.addEventListener('resize', () => requestAnimationFrame(() => {
			scene.duration(this.element.clientHeight * 0.95);
		}));

		let lastProgress = 0;
		scene.on('progress', (event) => {
			const progressInPercent = Math.round(event.progress * 10000) / 100;

			this.contentElement.style.transform = 'translate(-' + progressInPercent + '%, 0%) translate3d(0px, 0px, 0px)';
			const bgTransform = 'translate(0%, ' + (progressInPercent * 0.45) + '%) rotate(' + (progressInPercent * 0.05) + 'deg) scale(' + (1 + progressInPercent * 0.0025) + ') translate3d(0px, 0px, 0px)';
			this.whiteTriangle.style.transform = bgTransform;
			this.yellowLines.style.transform = bgTransform;
			this.greyTriangles.style.transform = 'translate(0%, ' + (progressInPercent * -1.8) + '%) scale(' + (1 + progressInPercent * 0.02) + ') translate3d(0px, 0px, 0px)';
			this.whiteYellow.style.transform = 'translate(0%, ' + progressInPercent + '%) scale(' + (1 + progressInPercent * 0.02) + ') translate3d(0px, 0px, 0px)';
			this.greyTrianglesMobile.style.transform = 'translate(0%, ' + Math.max(0, progressInPercent * -1.5) + 1 + '%) scale(' + (1 + progressInPercent * 0.03) + ') translate3d(0px, 0px, 0px)';

			// calculate a transition time between 0.05 and 0.3s based on the scroll change
			// everything over 50% should be capped to 0.3
			const progressChangeInPercent = Math.round(Math.abs(lastProgress - event.progress * 100));
			const transitionTime = Math.max(50, Math.min(progressChangeInPercent*6, 300));
			const transition = 'transform ' + (transitionTime * 0.001) + 's ease-out';
			lastProgress = event.progress;

			this.contentElement.style.transition = transition;
			this.whiteTriangle.style.transition = transition;
			this.yellowLines.style.transition = transition;
			this.greyTriangles.style.transition = transition;
			this.whiteYellow.style.transition = transition;
			this.greyTrianglesMobile.style.transition = transition;
		});

		scene.addTo(controller); // assign the scene to the controller
	}
}
